<template>
  <el-container class="layout">
    <!-- <el-header class="header">
      这是头部
    </el-header> -->
    <el-container class="main">
      <!-- <el-aside class="aside">
      </el-aside> -->
      <el-main ref="subtitles" class="body" style="background: #f7f7f7;position: relative;">
        <el-scrollbar class="scrollbar">
          <div :style="{height:subtitleperch+'px'}"></div>
          <div v-for="s in subtitles" :ref="'s'+ s.sid" :key="s.sid" :style="{filter:playSubtitleId==s.sid || isBlur?'blur(0px)': 'blur(3px)',color:playSubtitleId==s.sid?'#c61200':'',fontSize:playSubtitleId==s.sid?'14px':'12px',fontWeight: playSubtitleId==s.sid?'bold':''}" class="centre" style="padding: 5px;">
            <span v-if="playSubtitleId==s.sid" @mouseover="mouseInOut=true;" @mouseleave="mouseInOut=false">
              <span
                v-for="(w , index) in thisSubtitWords"
                :key="index"
                :class="{ 'take-background':w.isSelected,'hollow':w.isHollow,'hollow-font': mouseInOut }"
                :style="{filter:thisSubtitIsBlur?'blur(3px)': 'blur(0px)'}"
                @mouseover="onMouseoverTake(index,w)"
                @mousedown="onMousedownTake(index,w)"
                @mouseup="onMouseupTake"
              >{{ w.content }}</span>
            </span>
            <span v-else>{{ s.english }}</span>
          </div>
          <div :style="{height:subtitleperch+'px'}"></div>
          <!-- 新有道翻译 -->
          <el-dialog
            :visible.sync="dialogDictionaryVisible"
            placement="top-start"
            :width=" 1000 +'px'"
            @close="onDialog"
          >
            <div style="overflow:hidden;">
              <el-scrollbar
                style="height:100%;width: 100%;margin-top: 0px;margin-bottom: -20px;margin-right: -35px;"
              >
                <div class="row" style="width:770px">
                  <el-input
                    v-model="youdaoTitel"
                    placeholder="请输入查询的词"
                    @focus="onSelectWordFocus"
                    @blur="onSelectWordBlur"
                    @keyup.enter.native="onSelectWordEnter"
                  >
                    <el-button
                      v-if="ModelSentenceWordList.length>1"
                      slot="prepend"
                      icon="el-icon-back"
                      @click="onMSBack()"
                    />
                    <el-button slot="append" @click="onCollect">
                      <img
                        v-if="!isCollect"
                        src="../assets/images/player/未收藏.png"
                        style="width: 15px;margin-top: 5px;"
                      />
                      <img
                        v-else
                        src="../assets/images/player/已收藏.png"
                        style="width: 15px;margin-top: 5px;"
                      />
                    </el-button>
                  </el-input>
                  <el-button-group style="width:400px;margin-left: 10px;">
                    <el-button
                      type="success"
                      icon="el-icon-search"
                      @click="onSelectWordEnter"
                    >查词</el-button>
                    <el-button
                      type="primary"
                      icon="el-icon-tickets"
                      @click="onModelSentence"
                    >例句</el-button>
                    <el-button
                      icon="el-icon-tickets"
                      @click="onSceneVideo"
                    >情景视频</el-button>
                  </el-button-group>
                </div>
                <!-- 有道翻译 -->
                <iframe
                  v-if="isModelSentence== 1"
                  id="iframe"
                  ref="iframe"
                  :src="`${service}Sys/YouDaoHtml?word=${selectionValue}&uid=${uid}`"
                  frameborder="0"
                  width="1000px"
                  style="height: 380px;"
                ></iframe>
                <!-- 例句 -->
                <div v-if="isModelSentence == 2" style="width: 100%;" :style="{height:windowHeight - 310 + 'px'}">
                  <div
                    v-if="msLogin"
                    style="font-size: 10px;color: #777;margin: 20px 0px;"
                  >检索例句中...</div>
                  <el-scrollbar
                    v-else
                    class="scrollbar"
                    style="height: 100%;width: 100%;"
                  >
                    <div
                      v-for="(item, index) in PageModelSentenceList"
                      :key="index"
                      class="column ms-row"
                      style="cursor:pointer;"
                      @click.stop="osMSOpacity(PageModelSentenceIndex*20+ index)"
                    >
                      <span class="ms-english">
                        <span>{{ PageModelSentenceIndex*20+ index+1 }}.</span>
                        <div
                          v-if="((item.frequency0>0 || item.frequency1>0) && item.frequency2==0 && item.frequency3==0 && item.frequency4==0 && item.frequency5==0)"
                          class="frequency"
                          style="background: #EEA531;"
                        >初级</div>
                        <div
                          v-if="((item.frequency0>0 || item.frequency1>0 ) && item.frequency2>0 && item.frequency3==0 && item.frequency4==0 && item.frequency5==0)"
                          class="frequency"
                          style="background: #3D8D2B;"
                        >初中级</div>
                        <div
                          v-if="((item.frequency2>0 || item.frequency3>0) && item.frequency4==0 && item.frequency5==0)"
                          class="frequency"
                          style="background: #2FA2D2;"
                        >中级</div>
                        <div
                          v-if="((item.frequency2>0 || item.frequency3>0 ) && item.frequency4>0 && item.frequency5==0)"
                          class="frequency"
                          style="background: #2E63C3;"
                        >中高级</div>
                        <div
                          v-if="((item.frequency4>0 || item.frequency5>0))"
                          class="frequency"
                          style="background: #9D24B3;"
                        >高级</div>
                        <span
                          style="max-width: 580px;-webkit-touch-callout: text;-webkit-user-select: text; -khtml-user-select: text; -moz-user-select: text; -ms-user-select: text; user-select: text;margin-left: 5px;"
                          v-html="item.english"
                        ></span>
                        <div
                          class="play"
                          style="background: #5961cd;margin-left: 20px;"
                          @click.stop="onMsPlay(1,item.englishText)"
                        >
                          <img src="../assets/images/home/播放按钮.png" />
                        </div>
                        <div
                          class="play"
                          style="background: #B62B1A;margin-left: 10px;"
                          @click.stop="onMsPlay(2,item)"
                        >
                          <img src="../assets/images/home/播放按钮.png" />
                        </div>
                        <i
                          v-if="item.isMsLoading"
                          class="el-icon-loading"
                          style="margin-left:5px;"
                        ></i>
                      </span>
                      <span class="ms-chinese">
                        <span v-html="item.chinese"></span>
                      </span>
                      <span class="ms-provenance">来自:{{ item.grouping }}({{ item.name }})</span>
                    </div>
                  </el-scrollbar>
                  <div
                    v-if="ModelSentenceList.length>0"
                    class="row"
                    style="position:absolute;bottom: 20px;right: 40px;font-size: 12px;color: #c61200;background: white;z-index: 9999;"
                  >
                    <label
                      v-if="ModelSentenceList.length>=1"
                      :style="{'font-weight':PageModelSentenceIndex===0 ? 'bold' : ''}"
                      style="cursor:pointer;"
                      @click="onModelSentenceListPage(1)"
                    >&nbsp;第1页&nbsp;</label>
                    <label
                      v-if="ModelSentenceList.length>=20"
                      :style="{'font-weight':PageModelSentenceIndex===1 ? 'bold' : ''}"
                      style="cursor:pointer;"
                      @click="onModelSentenceListPage(2)"
                    >&nbsp;第2页&nbsp;</label>
                    <label
                      v-if="ModelSentenceList.length>=40"
                      :style="{'font-weight':PageModelSentenceIndex===2 ? 'bold' : ''}"
                      style="cursor:pointer;"
                      @click="onModelSentenceListPage(3)"
                    >&nbsp;第3页&nbsp;</label>
                    <label
                      v-if="ModelSentenceList.length>=60"
                      :style="{'font-weight':PageModelSentenceIndex===3 ? 'bold' : ''}"
                      style="cursor:pointer;"
                      @click="onModelSentenceListPage(4)"
                    >&nbsp;第4页&nbsp;</label>
                    <label
                      v-if="ModelSentenceList.length>=80"
                      :style="{'font-weight':PageModelSentenceIndex===4 ? 'bold' : ''}"
                      style="cursor:pointer;"
                      @click="onModelSentenceListPage(5)"
                    >&nbsp;第5页&nbsp;</label>
                  </div>
                </div>
                <!-- 情景视频 -->
                <div v-if="isModelSentence == 3" style="width: 100%;margin-top: 5px;" class="row" :style="{height:windowHeight - 310 + 'px'}">
                  <div style="width: 200px;margin-right: 10px;padding-bottom: 10px;" class="column">
                    <el-scrollbar>
                      <div v-for="(item) in scenedim" :key="item.md5" class="column" style="margin-bottom: 10px; background: #f8f8f8;border-radius: 6px;" @click="onDim(item)">
                        <el-image :src="item.cover" fit="cover" class="item-img" lazy style="height: 100px;border-radius: 6px 6px 0px 0px;" />
                        <label style="font-size: 12px;padding: 10px;">{{ item.name }}</label>
                      </div>
                    </el-scrollbar>
                  </div>
                  <div class="video column" style="width: 100%;height: 100%;position: relative;background: black;">
                    <video
                      id="sceneVideo"
                      ref="sceneVideo"
                      oncontextmenu="return false;"
                      style="outline: none;width: 100%;height: 100%;border-radius: 6px;"
                      :src="sceneVideoUrl"
                      controlslist="nodownload"
                      controls
                      @click.left="onsSceneVideoClickLeft"
                      @timeupdate="onTimeupdate"
                    ></video>
                    <!-- 字幕 -->
                    <div class="column" style="position: absolute;bottom: 30px;color: white;width: 100%;display: flex;justify-content: center;align-items: center;">
                      <div v-if="subtitle && subtitle.english" style="background: #000000c2;padding: 5px 10px;border-radius: 8px;font-size: 16px;font-weight: bold;"> <label>{{ subtitle.english }}</label></div>
                      <div v-if="subtitle && subtitle.chinese" style="background: #000000c2;padding: 5px 10px;border-radius: 8px;font-size: 14px;margin-top: 5px;"> <label>{{ subtitle.chinese }}</label></div>
                    </div>
                  </div>
                </div>
              </el-scrollbar>
            </div>
          </el-dialog>
        </el-scrollbar>
        <!-- 操作说明 -->
        <span class="centre" style="font-size:12px;position: absolute;bottom: 0px;left: 5px;width: 100%;background: #f7f7f7;">
          <strong>空格</strong>：<span style="color:#666666;">播放/暂停</span>；<span style="color:#565656;font-family:&quot;background-color:#FFFFFF;"><strong>←</strong><span style="color:#565656;font-family:&quot;background-color:#FFFFFF;"><strong>→</strong></span><strong></strong>：<span style="color:#666666;">上下句</span>；<strong><span style="font-size:14px;">+-</span></strong>：<span style="color:#666666;">增减倍率</span>；<strong>0</strong>：<span style="color:#666666;">正常倍率</span>；<strong>B</strong>：<span style="color:#666666;">模糊其它字幕</span>；<strong>N</strong>：<span style="color:#666666;">模糊当前字幕</span>；<strong>V</strong>：<span style="color:#666666;">语音合成当前字幕</span>；<strong>C</strong>：<span style="color:#666666;">语音合成当前选词(有道翻译)</span>；<span style="color:#565656;font-family:&quot;background-color:#FFFFFF;"><strong>&gt;</strong></span><strong></strong><strong>&lt;</strong>：<span style="color:#666666;">进退两秒</span>；</span>
        </span>
      </el-main>
    </el-container>
    <el-footer style="background: #f7f7f7;">
      <div class="column" style="overflow:hidden;height: 60px;">
        <div class="progress row centre" style="margin-bottom: -8px;margin-top: 10px;">
          <span title="上一句" @click="onLastSentence">
            <svg
              t="1632040304257"
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="753"
              width="14"
              height="14"
            >
              <path
                d="M57.727096 4.248201c11.271894 0 22.090646 3.823381 30.020621 10.648824a33.985609 33.985609 0 0 1 12.46139 25.772421v946.725787c0 20.108152-19.031941 36.421245-42.482011 36.421245S15.245084 1007.503385 15.245084 987.395233V40.641124C15.245084 20.532972 34.277026 4.248201 57.727096 4.248201z m910.87097 9.431007a73.097381 73.097381 0 0 1 35.854817 63.383161v873.883298a73.097381 73.097381 0 0 1-35.854817 63.383161 68.990787 68.990787 0 0 1-71.284816-0.934604L189.194761 576.452575v0.028321a73.267309 73.267309 0 0 1-34.382108-62.448557c0-25.602492 13.027817-49.307455 34.382108-62.476878L897.31325 14.613812a68.990787 68.990787 0 0 1 71.284816-0.934604z"
                fill="#000000"
                p-id="754"
              />
            </svg>
          </span>
          <div class="play-pause centre" style="width: 30px;height: 30px; margin-right: 10px;margin-left: 10px;" @click="onTogglePlay">
            <svg
              v-if="!isPlay"
              class="play-icon"
              t="1632038826276"
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="730"
              style="width: 30px;"
            >
              <path
                d="M780.8 475.733333L285.866667 168.533333c-27.733333-17.066667-64 4.266667-64 36.266667v614.4c0 32 36.266667 53.333333 64 36.266667l492.8-307.2c29.866667-14.933333 29.866667-57.6 2.133333-72.533334z"
                p-id="731"
                fill="#000000"
              />
            </svg>
            <svg
              v-else
              t="1632066311123"
              class="pause-icon"
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="2390"
              style="width: 20px;"
            >
              <path
                fill="#000000"
                d="M142.222222 0m99.555556 0l0 0q99.555556 0 99.555555 99.555556l0 824.888888q0 99.555556-99.555555 99.555556l0 0q-99.555556 0-99.555556-99.555556l0-824.888888q0-99.555556 99.555556-99.555556Z"
                p-id="2391"
              />
              <path
                d="M682.666667 0m99.555555 0l0 0q99.555556 0 99.555556 99.555556l0 824.888888q0 99.555556-99.555556 99.555556l0 0q-99.555556 0-99.555555-99.555556l0-824.888888q0-99.555556 99.555555-99.555556Z"
                fill="#000000"
                p-id="2392"
              />
            </svg>
          </div>
          <span title="下一句" @click="onNextSentence">
            <svg
              t="1632040345330"
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="996"
              width="14"
              height="14"
            >
              <path
                d="M967.11117 0.000284c-11.320879 0-22.186648 3.839997-30.151086 10.723547a34.133305 34.133305 0 0 0-12.515545 25.855979v950.840096c0 20.195539 19.114651 36.579525 42.666631 36.579525s42.666631-16.383986 42.666631-36.579525V36.57981C1009.777801 16.384271 990.663151 0.000284 967.11117 0.000284zM50.205268 9.500721A73.41505 73.41505 0 0 0 14.223076 73.159335v877.681046a73.41505 73.41505 0 0 0 35.982192 63.658614 69.290609 69.290609 0 0 0 71.594607-0.938666l711.195852-438.840523v0.028444A73.585716 73.585716 0 0 0 867.555698 512.028302c0-25.713756-13.112878-49.521737-34.559971-62.748392L121.799875 10.439387A69.290609 69.290609 0 0 0 50.205268 9.500721z"
                p-id="997"
                fill="#000000"
              />
            </svg>
          </span>
          <!-- 模糊字幕 -->
          <span title="模糊视频" style="margin-left: 20px;" @click="onBlur">
            <svg
              t="1632040892971"
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="9188"
              width="20"
              height="20"
            >
              <path
                d="M512 266.723556c-19.996444 0-39.196444 1.422222-57.628444 4.124444-23.324444 3.356444-45.056-12.088889-48.554667-34.531556-3.527111-22.442667 12.515556-43.377778 35.84-46.734222 22.613333-3.299556 46.08-5.034667 70.343111-5.034666 175.388444 0 303.36 91.022222 385.308444 177.777777a761.059556 761.059556 0 0 1 114.858667 159.175111c2.56 4.864 5.063111 9.756444 7.480889 14.705778l0.426667 0.938667 0.170666 0.341333v0.085334l0.028445 0.028444-38.968889 16.725333 39.025778 16.725334-0.085334 0.113777-0.085333 0.227556-0.341333 0.739556a624.355556 624.355556 0 0 1-22.613334 41.642666 770.389333 770.389333 0 0 1-67.84 96.227556 43.804444 43.804444 0 0 1-59.591111 6.144 40.078222 40.078222 0 0 1-7.196444-57.287111 686.478222 686.478222 0 0 0 71.168-104.533334 678.968889 678.968889 0 0 0-99.555556-136.675555C760.945778 340.053333 654.165333 266.723556 512 266.723556z m469.333333 287.601777l38.968889 16.725334a39.822222 39.822222 0 0 0 0-33.450667l-38.968889 16.725333zM186.965333 359.594667c8.391111 7.338667 13.368889 17.578667 13.909334 28.444444 0.512 10.894222-3.470222 21.532444-11.093334 29.582222a679.168 679.168 0 0 0-99.555555 136.704 679.367111 679.367111 0 0 0 99.555555 136.704C263.111111 768.568889 369.834667 841.927111 512 841.927111a394.808889 394.808889 0 0 0 134.4-23.239111c21.902222-7.395556 45.909333 3.470222 54.044444 24.405333 8.106667 20.935111-2.616889 44.259556-24.177777 52.536889A483.185778 483.185778 0 0 1 512 924.103111c-175.388444 0-303.36-91.022222-385.308444-177.777778a760.917333 760.917333 0 0 1-114.858667-159.175111c-2.56-4.835556-5.063111-9.756444-7.480889-14.705778l-0.426667-0.938666-0.170666-0.341334-0.028445-0.056888v-0.056889l38.968889-16.725334L3.640889 537.6l0.056889-0.028444 0.028444-0.085334 0.142222-0.341333 0.426667-0.938667 1.621333-3.185778c8.817778-17.464889 18.488889-34.531556 28.842667-51.171555a763.505778 763.505778 0 0 1 91.875556-119.523556 43.349333 43.349333 0 0 1 29.582222-13.368889c11.292444-0.540444 22.357333 3.299556 30.72 10.638223zM42.666667 554.325333L3.697778 537.6a39.822222 39.822222 0 0 0 0 33.450667l38.968889-16.725334z"
                p-id="9189"
                fill="#000000"
              />
              <path
                d="M469.816889 364.544c0-22.784 19.000889-41.272889 42.439111-41.272889 128.113778 0 229.233778 104.391111 229.233778 229.916445 0 14.734222-8.106667 28.359111-21.219556 35.754666a43.52 43.52 0 0 1-42.467555 0 41.073778 41.073778 0 0 1-21.219556-35.754666c0-82.915556-66.133333-147.370667-144.327111-147.370667-23.438222 0-42.439111-18.488889-42.439111-41.272889z m-130.929778 107.008c22.926222 4.807111 37.489778 26.737778 32.568889 49.038222a151.04 151.04 0 0 0-3.527111 32.597334c0 82.915556 66.133333 147.370667 144.327111 147.370666 11.207111 0 22.072889-1.28 32.483556-3.697778 22.755556-5.376 45.710222 8.248889 51.2 30.407112 5.546667 22.158222-8.476444 44.458667-31.260445 49.806222a229.063111 229.063111 0 0 1-52.423111 5.973333c-128.113778 0-229.233778-104.391111-229.233778-229.916444 0-17.066667 1.877333-33.848889 5.432889-49.92 2.360889-10.695111 9.016889-20.053333 18.488889-25.998223 9.443556-5.973333 20.935111-7.992889 31.943111-5.688888v0.028444zM100.209778 111.303111a43.320889 43.320889 0 0 1 60.017778 0L924.302222 854.186667c16.099556 16.213333 15.872 41.955556-0.512 57.856a43.320889 43.320889 0 0 1-59.505778 0.512L100.209778 169.671111a40.476444 40.476444 0 0 1 0-58.368z"
                p-id="9190"
                fill="#000000"
              />
            </svg>
          </span>
          <!-- 倍率 -->
          <el-dropdown style="margin-left: 20px;" @command="handleRateCommand">
            <span
              title="视频播放倍数"
              class="speed-rate"
            >{{ playbackRate }}x</span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item :disabled="playbackRate === 1.5" command="1.5">1.5x</el-dropdown-item>
              <el-dropdown-item :disabled="playbackRate === 1.2" command="1.2">1.2x</el-dropdown-item>
              <el-dropdown-item :disabled="playbackRate === 1" command="1">1x</el-dropdown-item>
              <el-dropdown-item :disabled="playbackRate === 0.8" command="0.8">0.8x</el-dropdown-item>
              <el-dropdown-item :disabled="playbackRate === 0.5" command="0.5">0.5x</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <!-- 进度条 -->
        <div class="row centre">
          <el-slider
            v-model="percentage"
            class="progress-bar"
            style="flex: 1;"
            :show-tooltip="false"
            :max="duration"
            @change="handlePercentageChange"
          />
          <span class="end-time" style="margin-left: 10px;margin-right: 10px;font-size: 12px;">{{ musictotaltime }}</span>
        </div>
      </div>
    </el-footer>
  </el-container>
</template>
<script>
import Vue from 'vue'
import {
  getSubtitle,
  modelSentence
} from '@/apis/subtitle'
import {
  getVideo,
  getAvName
} from '@/apis/video'
import {
  addWord
} from '@/apis/video'
import { hollowList,
  isCollect, addHollow, deHollow } from '@/apis/word-library'
// import { youDaoTranslate } from '@/apis/sys'
export default {
  name: 'Readingplayer',
  components: {},
  props: {},
  data() {
    return {
      uid: '',
      service: Vue.$conf.service[Vue.$conf.environment],
      video: {},
      subtitles: [],
      audio: {},
      youdaoaudio: {},
      playSubtitleId: '',
      subtitleperch: 0,
      musictotaltime: 0,
      percentage: 0,
      duration: 0,
      isPlay: false,
      subtitIndex: -1,
      isBlur: false,
      thisSubtitIsBlur: false,
      thisSubtitWords: [],
      englishTextStr: '',
      allHollowList: [],
      mouseInOut: false,
      dialogDictionaryVisible: false,
      youdaoTitel: '',
      ModelSentenceWordList: [],
      isCollect: false,
      selectionValue: '',
      msLogin: true,
      ModelSentenceList: [],
      isModelSentence: 1,
      playbackRate: 1, // 播放速率
      PageModelSentenceIndex: 0, // 例句分页索引
      PageModelSentenceList: [], // 例句分页集合
      sceneVideoUrl: '',
      subtitle: '',
      sceneVideoSubtitle: [],
      windowWidth: document.documentElement.clientWidth,
      windowHeight: document.documentElement.clientHeight, // 挖空字幕距离
      translate: {
        basic: []
      }, // 有道翻译数据
      scenedim: [],
      youdaoTextSize: 0 // 有道翻译字体增加大小
    }
  },
  computed: {},
  watch: {},
  created() {
    // 禁用鼠标右键
    window.oncontextmenu = function(e) {
      return false
    }
    var userInfo = JSON.parse(localStorage.getItem('user'))
    this.uid = userInfo.id
    if (localStorage.getItem('youdaoTextSize') != null) {
      this.youdaoTextSize = Number(localStorage.getItem('youdaoTextSize'))
    }
  },
  beforeRouteLeave(to, form, next) {
    this.audio.pause()
    document.onkeydown = {}
    next()
  },
  async mounted() {
    var that = this
    var res = await getVideo({ id: that.$route.query.id })
    that.video = res.data
    res = await getSubtitle({ md5: that.$route.query.md5 })
    that.subtitles = res.data.reverse()
    that.audio = new Audio()
    that.youdaoaudio = new Audio()
    that.audio.src = that.video.url
    that.audio.addEventListener(
      'canplay',
      function(e) {
        var total = parseInt(that.audio.duration)
        this.musictotaltimemode = total
        var minute = total % 60
        var seconds = (total - minute) / 60
        that.musictotaltime = seconds + ':' + minute
        that.duration = that.audio.duration
      },
      false
    )
    // 播放进度
    that.audio.addEventListener(
      'timeupdate',
      function(event) {
        var time = that.audio.currentTime * 1000
        that.percentage = parseInt(that.audio.currentTime)
        const currentSubtitle = that.subtitles.find((x, i) => {
          if (x.startMillisecond <= time && x.endMillisecond > time) {
            that.subtitIndex = i
            return x
          }
        })
        if (currentSubtitle) {
          that.englishTextStr = currentSubtitle.englishText
          that.thisSubtitWords = []
          currentSubtitle.englishText.split(/\b/).forEach((elem, index) => {
            that.thisSubtitWords.push({
              content: elem,
              isSelected: false,
              isHollow: false
            })
          })
          that.playSubtitleId = currentSubtitle.sid
          that.$refs['s' + that.playSubtitleId][0].scrollIntoView({
            block: 'center'
          })
          that.thisHollowSubtitles()
        }
      },
      false
    )
    // 播放结束
    that.audio.addEventListener(
      'ended',
      function() {
        that.audio.pause()
      },
      false
    )
    // 开始播放
    this.audio.addEventListener(
      'play',
      function() {
        that.isPlay = true
      },
      false
    )
    // 暂停播放
    this.audio.addEventListener(
      'pause',
      function() {
        that.isPlay = false
      },
      false
    )
    that.audio.play()
    // 获取全局挖空列表
    hollowList().then(res => {
      this.allHollowList = res.data
    })
    that.$nextTick(function() {
      that.subtitleperch = that.$refs.subtitles.$el.offsetHeight / 2
    })
    that.onkeydown()
    window.onresize = () => {
      return (() => {
        window.fullHeight = document.documentElement.clientHeight
        window.fullWidth = document.documentElement.clientWidth
        that.windowHeight = window.fullHeight // 高
        that.windowWidth = window.fullWidth // 宽
      })()
    }
  },
  methods: {
    // 进度条点击
    handlePercentageChange(value) {
      this.audio.currentTime = value
    },
    // 播放暂停
    onTogglePlay() {
      if (this.isPlay) {
        this.audio.pause()
      } else {
        this.audio.play()
      }
    },
    // 上一句
    onLastSentence() {
      if (this.subtitIndex - 1 === -1) {
        return
      }
      var subtitle = this.subtitles[this.subtitIndex - 1]
      this.audio.currentTime = subtitle.startMillisecond / 1000
    },
    // 下一句
    onNextSentence() {
      if (this.subtitIndex + 1 === this.subtitles.length) {
        return
      }
      var subtitle = this.subtitles[this.subtitIndex + 1]
      this.audio.currentTime = subtitle.startMillisecond / 1000
    },
    // 模糊字幕
    onBlur() {
      this.isBlur = !this.isBlur
    },
    // 模糊当前字幕
    onThisSubtitIsBlur() {
      this.thisSubtitIsBlur = !this.thisSubtitIsBlur
    },
    // 单词鼠标按下事件
    onMousedownTake(index, obj) {
      this.takeButtonsType = event.buttons
      this.dialogDictionaryVisible = false
      for (let i = 0; i < this.thisSubtitWords.length; i++) {
        this.thisSubtitWords[i].isSelected = false
      }
      this.isSelectedInedx = index
      this.isSelectedTake = true
      obj.isSelected = true
      this.audio.pause()
    },
    // 单词鼠标移入事件
    onMouseoverTake(index, obj) {
      if (!this.isSelectedTake) {
        return
      }
      // *********************如果挖空单词超过1个则返回 只能挖空一个词*********************
      var selectedEl = this.thisSubtitWords.filter((item, index) => item.isSelected === true)
      if (this.takeButtonsType === 2 && selectedEl.length === 1) return
      // *********************
      // 滑词逻辑
      if (this.isSelectedInedx <= index) {
        // 右滑
        for (let i = 0; i < this.thisSubtitWords.length; i++) {
          // 标记选择
          if (i >= this.isSelectedInedx && i <= index) {
            this.thisSubtitWords[i].isSelected = true
          } else {
            // 取消选择
            this.thisSubtitWords[i].isSelected = false
          }
        }
      } else {
        // 左滑
        for (let i = 0; i < this.thisSubtitWords.length; i++) {
          if (i <= this.isSelectedInedx && i >= index) {
            this.thisSubtitWords[i].isSelected = true
          } else {
            this.thisSubtitWords[i].isSelected = false
          }
        }
      }
    },
    // 单词鼠标松开事件
    onMouseupTake(e) {
      this.isSelectedTake = false
      this.isModelSentence = 1
      this.ModelSentenceList = []
      // 处理单词
      var selectedEl = this.thisSubtitWords.filter((item, index) => item.isSelected === true)
      if (selectedEl.length === 0 && this.isSelectedInedx >= 0) {
        selectedEl = [this.thisSubtitWords[this.isSelectedInedx]]
      } else if (selectedEl.length === 0 && this.isSelectedInedx < 0) return
      var paragraph = Array.from(selectedEl, x => x.content).join('')
      // 删除特殊字符
      paragraph = paragraph.replace(/\,/g, ' ')
      paragraph = paragraph.replace(/\./g, ' ')
      paragraph = paragraph.replace(/\?/g, ' ')
      paragraph = paragraph.replace(/\!/g, ' ')
      this.selectionValue = paragraph
      if (this.takeButtonsType === 1) this.onLoginYoudao()
      if (this.takeButtonsType === 2) {
        var isWord = this.allHollowList.filter((item, index) => {
          if (item.word != null && item.word.toLowerCase() === this.selectionValue.trim().toLowerCase()) {
            this.allHollowList.splice(index, 1)
            return item
          }
        })
        if (isWord.length > 0) {
          deHollow({ hid: isWord[0].id }).then(res => {})
        } else {
          this.allHollowList.push({ word: this.selectionValue.trim() })
          addHollow({ word: this.selectionValue.trim() }).then(res => {})
        }
        this.thisHollowSubtitles()
      }
    },
    // 当前挖空字幕处理
    thisHollowSubtitles() {
      this.thisSubtitWords.forEach((ele) => {
        ele.isHollow = false
        var word = this.allHollowList.filter((item, index) => item.word.trim().toLowerCase() === ele.content.trim().toLowerCase())
        if (word.length > 0) {
          ele.isHollow = true
        }
      })
    },
    // 有道查词 获取焦点
    onSelectWordFocus() {
      document.onkeydown = {}
    },
    // 有道查词 失去焦点
    onSelectWordBlur() {
      var that = this
      document.onkeydown = function(e) {
        that.sysKey(e.key.trim().toLowerCase(), that)
      }
      document.onkeyup = function(e) {}
      that.keydown = ''
    },
    // 查词
    onSelectWordEnter() {
      this.isModelSentence = 1
      this.selectionValue = this.youdaoTitel
      this.youdaoaudio.src = `http://dict.youdao.com/speech?audio=${this.youdaoTitel}`
      this.youdaoaudio.play()
    },
    // 收藏单词
    onCollect() {
      // var that = this
      this.selectionValue = this.youdaoTitel
      addWord({
        word: this.selectionValue,
        type: 1,
        en: this.englishTextStr,
        cn: this.currentSubtitleZh,
        subtitle: this.currentSubtitleSid
      }).then(res => {
        this.isCollect = true
        // that.$notify.success({
        //   message: '收藏成功'
        // })
      })
    },
    // 加载有道翻译
    onLoginYoudao() {
      console.log(this.windowWidth, this.windowHeight)
      this.youdaoTitel = this.selectionValue
      this.youdaoaudio.src = `http://dict.youdao.com/speech?audio=${this.selectionValue}`
      this.youdaoaudio.play()
      // youDaoTranslate({ word: this.youdaoTitel.trim(), uid: this.uid, isApi: true }).then(res => {
      //   this.translate = res.data
      // })
      isCollect({ word: this.selectionValue }).then(res => {
        this.isCollect = res.data
      })
      this.dialogDictionaryVisible = true
    },
    // 搜索字幕例句
    onModelSentence() {
      var that = this
      this.isModelSentence = 2
      this.msLogin = true
      // 例句关键词搜索记录
      if (
        that.ModelSentenceWordList.length === 0 ||
        that.ModelSentenceWordList[that.ModelSentenceWordList.length - 1] !==
          this.youdaoTitel.trim()
      ) {
        that.ModelSentenceWordList.push(this.youdaoTitel.trim())
      }
      var example = localStorage.getItem('example')
      var zhOpacity = 0
      var enOpacity = 0
      if (example) {
        switch (example) {
          case '1':
            zhOpacity = 1
            enOpacity = 1
            break
          case '2':
            zhOpacity = 0
            enOpacity = 1
            break
          case '3':
            zhOpacity = 1
            enOpacity = 0
            break
          case '4':
            zhOpacity = 0
            enOpacity = 0
            break
        }
      }
      // 查询条件/排序
      var level = localStorage.getItem('level')
      var sort = localStorage.getItem('sort')
      var where = '1=1'
      if (level) {
        level = JSON.parse(level)
        if (level.length < 5 && level.length !== 0) {
          level.forEach(x => {
            if (where === '1=1') {
              where = `${where} and (`
            } else {
              where = `${where} or`
            }
            switch (x) {
              case '初级':
                where = `${where} ((t1.Frequency0>0 or t1.Frequency1>0) and t1.Frequency2=0 and t1.Frequency3=0 and t1.Frequency4=0 and t1.Frequency5=0)`
                break
              case '初中级':
                where = `${where} ((t1.Frequency0>0 or t1.Frequency1>0 ) and t1.Frequency2>0 and t1.Frequency3=0 and t1.Frequency4=0 and t1.Frequency5=0)`
                break
              case '中级':
                where = `${where} ((t1.Frequency2>0 or t1.Frequency3>0) and t1.Frequency4=0 and t1.Frequency5=0)`
                break
              case '中高级':
                where = `${where} ((t1.Frequency2>0 or t1.Frequency3>0 ) and t1.Frequency4>0 and t1.Frequency5=0)`
                break
              case '高级':
                where = `${where} ((t1.Frequency4>0 or t1.Frequency5>0))`
                break
            }
          })
          where = `${where} )`
        } else {
          where = ''
        }
      }
      if (sort) {
        sort = JSON.parse(sort)
        var orderBy = ''
        if (sort.length > 0) {
          if (where === '') {
            where = '1=1'
          }
          sort.forEach(x => {
            switch (x) {
              case '学习时间':
                orderBy = `${orderBy} t5.LearningTime DESC,`
                break
              case '例句长度':
                orderBy = `${orderBy} if(ISNULL(t1.Length),10000,t1.Length),`
                // where = `${where} and t1.Length>0`
                break
              case '复杂程度':
                orderBy = `${orderBy} if(ISNULL(t1.MaxLevel),7,t1.MaxLevel),`
                // where = `${where} and t1.MinLevel>0`
                break
            }
          })
          orderBy = orderBy.substring(0, orderBy.lastIndexOf(','))
        }
      }
      // 查询例句
      modelSentence({
        word: this.youdaoTitel.trim(),
        orderBy: orderBy,
        where: where
      }).then(res => {
        for (let index = 0; index < res.data.length; index++) {
          const element = res.data[index]
          element.englishText = element.english
          that.youdaoTitel = that.youdaoTitel.trim()
          var symbol = that.youdaoTitel.substring(that.youdaoTitel.length - 1)
          if (
            symbol === '.' ||
            symbol === ',' ||
            symbol === '?' ||
            symbol === '!' ||
            symbol === '！' ||
            symbol === '？'
          ) {
            that.youdaoTitel = that.youdaoTitel.substring(
              0,
              that.youdaoTitel.length - 1
            )
          }
          var reg = new RegExp(`\\b${that.youdaoTitel}\\b`, 'i', 'g')
          element.english = element.english.replace(
            reg,
            `<span style="color: #00a803;opacity: 0;" id="msword${index}">${that.youdaoTitel}</span>`
          )
          element.english = `<span style="opacity: ${enOpacity};" id="msEnglish${index}">${element.english}</span>`
          if (element.chinese === null) {
            element.chinese = '无中文字幕'
          }
          element.chinese = `<span style="opacity: ${zhOpacity};" id="msChinese${index}">${element.chinese}</span>`
          element.isMsLoading = false
        }
        this.ModelSentenceList = res.data
        this.PageModelSentenceIndex = 0
        if (this.ModelSentenceList.length > 0) {
          if (this.ModelSentenceList.length < 20) {
            this.PageModelSentenceList = this.ModelSentenceList.slice(
              0,
              this.ModelSentenceList.length
            )
          } else {
            this.PageModelSentenceList = this.ModelSentenceList.slice(0, 20)
          }
        } else {
          this.PageModelSentenceList = []
        }
        this.msLogin = false
      })
    },
    // 例句翻页
    onModelSentenceListPage(page) {
      this.PageModelSentenceIndex = page - 1
      switch (page) {
        case 1:
          this.PageModelSentenceList = this.ModelSentenceList.slice(0, 20)
          break
        case 2:
          this.PageModelSentenceList = this.ModelSentenceList.slice(20, 40)
          break
        case 3:
          this.PageModelSentenceList = this.ModelSentenceList.slice(40, 60)
          break
        case 4:
          this.PageModelSentenceList = this.ModelSentenceList.slice(60, 80)
          break
        case 5:
          this.PageModelSentenceList = this.ModelSentenceList.slice(80, 100)
          break
      }
    },
    // 合成例句发音
    onMsPlay(type, obj) {
      // console.log(obj)
      var that = this
      if (type === 1) {
        this.youdaoaudio.src = `http://dict.youdao.com/speech?audio=${obj}`
        this.youdaoaudio.play()
      } else if (type === 2) {
        obj.isMsLoading = true
        this.youdaoaudio.src = obj.audio
        this.youdaoaudio.currentTime = obj.startMillisecond / 1000
        var audioTimeupdate = function(event) {
          if (that.youdaoaudio.currentTime >= obj.endMillisecond / 1000) {
            that.youdaoaudio.pause()
            that.youdaoaudio.removeEventListener('timeupdate', audioTimeupdate)
            that.youdaoaudio.removeEventListener('canplay', canplay)
          }
        }
        var canplay = function() {
          obj.isMsLoading = false
        }
        this.youdaoaudio.play()
        this.youdaoaudio.addEventListener('timeupdate', audioTimeupdate)
        this.youdaoaudio.addEventListener('canplay', canplay)
      }
    },
    // 例句隐藏
    osMSOpacity(index) {
      if (document.getElementById('msEnglish' + index).style.opacity !== '1') {
        document.getElementById('msEnglish' + index).style.opacity = 1
      } else if (
        document.getElementById('msword' + index).style.opacity !== '1'
      ) {
        document.getElementById('msword' + index).style.opacity = 1
      } else if (
        document.getElementById('msChinese' + index).style.opacity !== '1'
      ) {
        document.getElementById('msChinese' + index).style.opacity = 1
      } else {
        var example = localStorage.getItem('example')
        if (example && example === '1') {
          document.getElementById('msword' + index).style.opacity = 0
        } else if (example && example === '2') {
          document.getElementById('msChinese' + index).style.opacity = 0
          document.getElementById('msword' + index).style.opacity = 0
        } else if (example && example === '3') {
          document.getElementById('msEnglish' + index).style.opacity = 0
          document.getElementById('msword' + index).style.opacity = 0
        } else if (!example || example === '4') {
          document.getElementById('msEnglish' + index).style.opacity = 0
          document.getElementById('msword' + index).style.opacity = 0
          document.getElementById('msChinese' + index).style.opacity = 0
        }
      }
    },
    // 设置速率
    handleRateCommand(command) {
      this.playbackRate = Number(command)
      this.audio.playbackRate = this.playbackRate
    },
    // 快捷键
    onkeydown() {
      var that = this
      document.onkeydown = function(e) {
        that.sysKey(e.key.trim().toLowerCase(), that)
        return false
      }
      document.onkeyup = function(e) {}
      that.keydown = ''
    },
    // 实现快捷键
    sysKey(key, that) {
      switch (key) {
        case 'space': // 播放/暂停
        case '':
          that.onTogglePlay()
          break
        case 'd': // 下一句  arrowleft（左）
        case 'arrowright':
          that.onNextSentence()
          break
        case 'a': // 上一句
        case 'arrowleft':
          that.onLastSentence()
          break
        case '+': // 加0.1倍
        case 'shift++':
        case '=':
          var rateAdd = Number(that.playbackRate + 0.1).toFixed(1)
          that.handleRateCommand(rateAdd)
          break
        case '-': // 减0.1倍
        case 'shift+—':
        case 'shift+_':
          var rateMinus = Number(that.playbackRate - 0.1).toFixed(1)
          that.handleRateCommand(rateMinus)
          break
        case '<': // 后退2秒
        case 'shift+<':
        case ',':
        case '，':
          that.audio.currentTime -= 2
          break
        case '>': // 前进两秒
        case 'shift+>':
        case '。':
        case '.':
          that.audio.currentTime += 2
          break
        case 'b': // 模糊其它字幕
          that.onBlur()
          break
        case 'n': // 模糊当前字幕
          that.onThisSubtitIsBlur()
          break
        case '0': // 正常倍速
          that.handleRateCommand(1)
          break
        case 'v': // 语音合成整句vv
          this.audio.pause()
          that.youdaoaudio.src = `http://dict.youdao.com/speech?audio=${that.englishTextStr}`
          that.youdaoaudio.play()
          break
        case 'c': // 语音合成选择的句
          if (this.dialogDictionaryVisible) {
            that.youdaoaudio.src = `http://dict.youdao.com/speech?audio=${that.youdaoTitel}`
            that.youdaoaudio.play()
          }
          break
      }
    },
    // 搜索情景视频
    onSceneVideo() {
      this.isModelSentence = 3
      getAvName({
        name: this.youdaoTitel.trim()
      }).then(res => {
        console.log(res)
        if (res.data.exact) {
          this.sceneVideoUrl = res.data.exact.url
          this.scenarioVideoBut = true
          this.sceneVideoMd5 = res.data.exact.md5
          this.scenedim = res.data.dim
          this.onScenarioVideo(true)
        } else {
          this.scenarioVideoBut = false
          this.sceneVideoUrl = ''
          this.sceneVideoMd5 = ''
        }
      })
    },
    // 联想视频播放
    onScenarioVideo(isplay = false) {
      var that = this
      this.isScenarioVideo = true
      this.isFindIframe = false
      this.isSentence = false
      getSubtitle({ md5: this.sceneVideoMd5 }).then(res => {
        this.sceneVideoSubtitle = res.data
      })
      this.$nextTick(() => {
        // 播放事件
        this.$refs.sceneVideo.addEventListener('play', function() {
          that.$refs.sceneVideo.controls = true
          that.sceneVideoIsPlay = true
        })

        // 暂停事件
        this.$refs.sceneVideo.addEventListener('pause', function() {
          that.$refs.sceneVideo.controls = false
          that.sceneVideoIsPlay = false
        })
        if (isplay) {
          that.$refs.sceneVideo.play()
        }
      })
    },
    // 情景视频左键点击
    onsSceneVideoClickLeft() {
      if (!this.sceneVideoIsPlay) this.$refs.sceneVideo.play()
    },
    // 情景视频播放进度
    onTimeupdate(e) {
      const currentMillisecondCeil = Math.ceil(this.$refs.sceneVideo.currentTime * 1000)
      const currentSubtitle = this.sceneVideoSubtitle.find((x, index) => {
        if (x.startMillisecond <= currentMillisecondCeil) {
          return true
        }
        return false
      })
      this.subtitle = currentSubtitle
    },
    // 有道查询窗口关闭
    onDialog() {
      this.audio.pause()
      this.youdaoaudio.pause()
      this.$refs.sceneVideo.pause()
    },
    onDim(item) {
      this.sceneVideoUrl = item.url
      this.scenarioVideoBut = true
      this.sceneVideoMd5 = item.md5
      this.sceneVideoSubtitle = []
      this.subtitle = {}
      this.onScenarioVideo(true)
    },
    // 设置有道翻译字体
    onYoudaoTextSize(e) {
      localStorage.setItem('youdaoTextSize', e)
    }
  }
}
</script>
<style lang='less' scoped>
video::-webkit-media-controls-fullscreen-button{ display: none !important; }
//变量定义
@primary-clor: #6a6aee;
@padding-horizontal:20px;
@padding-vertical:10px;
@list-operation-height:50px;
@tabs-top-height:40px;
.layout{
  min-height: 0;
  background: #ffff;
  border-radius: 10px;
  .aside{
    width: 200px;
    //tabs 容器
    .tabs{
      height: 100%;
      // tabs 顶部
      &-top{
        height: @tabs-top-height;
        display: flex;
        align-items: center;
        text-align: center;
        //tabs顶部项
        .item{
          width: 200px;
          height: @tabs-top-height;
          cursor: pointer;
          font-size:18px;
          color:rgb(134, 134, 134);
          line-height: @tabs-top-height;
          &.is-active{
            color:@primary-clor;
            position: relative;
            &:after{
              content: '';
              width: 10px;
              height: 5px;
              border-radius: 5px;
              background: @primary-clor;
              position: absolute;
              bottom: -2px;
              left: 50%;
              transform: translate(-50%,-50%);
            }
          }
        }
      }
      &-content{
        height: calc(100% - @tabs-top-height);
        //视频列表
        .list{
          box-sizing: border-box;
          padding: @padding-vertical @padding-horizontal;
          //计算高度 =内容高度 - operation元素的高度
          height:calc(100% - @list-operation-height);
        }
        //操作
        .operation{
          height: @list-operation-height;
        }
      }
    }

    //所有的滚动条
    .scrollbar{
        height:100%;
        ::v-deep .el-scrollbar__wrap{
          overflow-x: hidden;
        }
    }
  }
  .main{
    overflow-y: auto;
    .body{
      padding: 0;
      .scrollbar{
        height: 100%;
        ::v-deep .el-scrollbar__wrap{
          overflow-x: hidden;
        }
      }
    }
  }
}
.centre {
  display: flex;
  justify-content: center;
  align-items: center;
}
.row {
  display: flex;
  flex-direction: row;
}

.column {
  display: flex;
  flex-direction: column;
}
//禁止文本选择
* {
  -webkit-touch-callout: none; /*系统默认菜单被禁用*/
  -webkit-user-select: none; /*webkit浏览器*/
  -khtml-user-select: none; /*早期浏览器*/
  -moz-user-select: none; /*火狐*/
  -ms-user-select: none; /*IE10*/
  user-select: none;
}
.take-background {
  background: #f7dc00;
  color: #282828;
  // border-radius: 5px;
}
.hollow{
  border-width: 0px 0px 2px 0px;
  border-color: #c61200;
  border-style: solid;
  color: transparent;
}
.hollow-font{
  color: #c61200 !important;
}
// 例句
.ms-row {
  margin: 10px 0px;
  padding: 5px;
  border-width: 0 0 1px 0;
  border-color: #f9f6f6;
  border-style: solid;
  .ms-english {
    font-weight: bold;
    display: flex;
    align-items: center;
    // justify-content: center;
    color: #333333;
    font-size: 14px;
    margin-bottom: 5px;
    .frequency {
      padding: 0px 8px;
      color: white;
      border-radius: 2px;
      font-size: 12px;
      font-weight: normal;
      margin-left: 4px;
    }
    .play {
      width: 28px;
      height: 28px;
      border-radius: 5px;
      // 左右上下居中
      display: flex;
      justify-content: center;
      align-items: center;
      img {
        width: 12px;
        height: 12px;
      }
    }
  }

  .ms-chinese {
    color: #666666;
    font-size: 12px;
    margin-bottom: 5px;
  }

  .ms-provenance {
    color: #959595;
    font-size: 12px;
  }
}
</style>
<style>
/* .el-tooltip__popper {
  padding: 6px !important;
}
.el-popper[x-placement^='top'] {
  background: red;
} */
/* .el-slider__runway {
  height: 2px;
  background-color: #ffffff49 !important;
}
.el-slider__bar {
  height: 2px;
  background-color: #858585;
} */
.el-slider__button {
  width: 0px !important;
  height: 0px !important;
}
.el-slider__runway {
  height: 2px;
  background-color: #d0d0d032 !important;
}
.el-slider__bar {
  height: 2px;
  background-color: #c61200 !important;
}
.el-slider__button {
  border: solid 4px #c61200 !important;
  margin-top: -4px !important;
}
.el-tooltip__popper {
  padding: 6px !important;
}
</style>
